import { __assign, __makeTemplateObject } from "tslib";
import * as React from 'react';
import styled, { useTheme } from 'styled-components';
import { motion } from 'framer-motion';
import ReactTreeContext from './Context';
import { AnyNode } from './Nodes';
import { ColumnBlock, TextBlock } from './Elements';
var TreeWrapper = styled(motion.div)(function (_a) {
    var $backgroundColor = _a.$backgroundColor, $fontFamily = _a.$fontFamily, $fontSize = _a.$fontSize, $truncateLongText = _a.$truncateLongText;
    return [
        "& * {\n      font-size: ".concat($fontSize ? $fontSize : 'initial', ";\n      font-family: ").concat($fontFamily ? $fontFamily : 'initial', ";\n    }"),
        "display: flex; flex-direction: column; flex: 1;",
        "background-color: ".concat($backgroundColor || 'initial', ";"),
        "padding: 1rem;",
        $truncateLongText
            ? "overflow-x: hidden; text-overflow: ellipsis; white-space: nowrap;"
            : ""
    ];
});
var TreeMessage = styled(motion.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  font-family: ", ";\n"], ["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  font-family: ", ";\n"])), function (_a) {
    var _b;
    var options = _a.theme, $theme = _a.$theme;
    return (_b = options.themes[$theme].text) === null || _b === void 0 ? void 0 : _b.fontFamily;
});
var TreeRoot = function (_a) {
    var _b, _c, _d, _e;
    var loading = _a.loading, containerStyles = _a.containerStyles, RenderNode = _a.RenderNode, RenderIcon = _a.RenderIcon;
    var options = useTheme();
    var _f = ReactTreeContext.useReactTreeContext(), nodes = _f.nodes, theme = _f.theme, appOptions = _f.options;
    var currentTheme = options.themes[theme];
    if (!currentTheme)
        throw new Error('Specified theme does not exit');
    var fontSize = ((_b = currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.text) === null || _b === void 0 ? void 0 : _b.fontSize) || 'std';
    if (fontSize in options.app.fontSizes) {
        fontSize = options.app.fontSizes[fontSize];
    }
    return (React.createElement(TreeWrapper, { "$backgroundColor": (_d = (_c = currentTheme.nodes) === null || _c === void 0 ? void 0 : _c.folder) === null || _d === void 0 ? void 0 : _d.bgColor, "$fontFamily": (_e = currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.text) === null || _e === void 0 ? void 0 : _e.fontFamily, "$fontSize": fontSize, "$truncateLongText": appOptions.truncateLongText, "data-test-id": "react-tree-root", style: __assign(__assign({}, containerStyles), { display: 'flex', flexDirection: 'column' }) },
        !loading && nodes.length === 0 && (React.createElement(ColumnBlock, { style: { justifyContent: 'center', alignItems: 'center', flex: 1 } },
            React.createElement(TextBlock, null, appOptions.messages.noData))),
        loading && React.createElement(TreeMessage, { "$theme": theme }, "Loading (more)..."),
        !loading && React.createElement(AnyNode, { RenderNode: RenderNode, RenderIcon: RenderIcon })));
};
export default TreeRoot;
var templateObject_1;
//# sourceMappingURL=TreeRoot.js.map